// Libraries
import { useContext } from 'react';
import styled from 'styled-components';

// Components
import { Flex, Space } from 'antd';
import { P } from 'components/fontSystem';

// Dependencies
import TranslationsContext from 'providers/translationsProvider';
import bfbTheme from 'styles/b4b-theme';

// Assets
import awsLogo from 'static/images/logo_aws.png';
import gdprLogo from 'static/images/logo_gdpr.png';

const SecurityText = () => {
  const { t } = useContext(TranslationsContext);
  return (
    <SecurityStatement>
      <Space size={10}>
        <img width={30} src={awsLogo} alt="" />
        <P color={bfbTheme.grey} $italic $mb0>
          {t('AWS security standards keep your data save and protected.')}
        </P>
      </Space>

      <Space size={10}>
        <img width={30} src={gdprLogo} alt="" />
        <P color={bfbTheme.grey} $italic $mb0>
          {t('GDPR compliance protects all personal data.')}
        </P>
      </Space>
    </SecurityStatement>
  );
};

const SecurityStatement = styled(Flex)`
  flex-direction: column;
  gap: 5px;
  margin-top: 40px;
  margin-bottom: 20px;
`;

export default SecurityText;
